// extracted by mini-css-extract-plugin
export default {"container":"GesansuList_container__P09xe","child01":"GesansuList_child01__bbgIN","child02":"GesansuList_child02__iN9Z9"};